import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none",
  viewBox: "0 0 34 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#eceaff",
      d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#887bff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.408 23.067a7.5 7.5 0 0 1-8.817 0m7.697-12.808a7.5 7.5 0 0 1 4.139 7.785m-14.854 0a7.5 7.5 0 0 1 4.14-7.785m7.412 6.74a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
    }, null, -1)
  ]))]))
}
export default { render: render }